import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { MantineProvider } from '@mantine/core'
import { Notifications } from '@mantine/notifications'
import { ModalsProvider } from '@mantine/modals'
import { App } from './App'
import { theme } from './styles/theme'
import { StorageProvider } from './contexts/StorageContext'
import '@mantine/core/styles.css'
import '@mantine/notifications/styles.css'
import '@mantine/dates/styles.css'
import '@mantine/dropzone/styles.css'
import '@mantine/carousel/styles.css'
import '@mantine/nprogress/styles.css'
import './styles/globals.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <MantineProvider theme={theme} forceColorScheme="light">
        <StorageProvider>
          <ModalsProvider>
            <Notifications />
            <App />
          </ModalsProvider>
        </StorageProvider>
      </MantineProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
